<div
  class="scrunch-container"
  [class]="{ show: embeddedReportService.show$ | async }">
  <div class="main-content">
    <ng-content></ng-content>
  </div>
  <div class="report-container">
    <button
      class="close-button"
      matTooltip="Close Report"
      (click)="embeddedReportService.setShow(false)">
      <mat-icon>close</mat-icon>
    </button>
    <button
      class="open-button"
      matTooltip="Open in new window"
      (click)="embeddedReportService.popupReport($event)">
      <mat-icon>open_in_new</mat-icon>
    </button>
    @if (
      (embeddedReportService.show$ | async) &&
      (embeddedReportService.url$ | async) !== null
      ) {
      <iframe
        width="100%"
        [src]="embeddedReportService.url$ | async">
      </iframe>
    }
  </div>
</div>
